function deleteExecutorValidate() {
  const deleteButton = document.querySelector('.deleteValidate');
  let url = window.location.href;
  let executorId = getNumberFromUrl(url);

  deleteButton.addEventListener('click', function (event) {
    event.preventDefault(); // prevent default event first
    checkActiveSubordinates(deleteButton, executorId, event);
  });
}

// Check if the user has active subordinates
function checkActiveSubordinates(deleteButton, id, event) {
  const errorDiv = document.getElementById('deleteError');

    console.log(id[0]);
  $.ajax({
    type: 'POST',
    url: '/api/user/executor/subordinates/check/',
    data: {
      executor_id: id,
    },
    success: function () {
      errorDiv.classList.add('is-hidden');
      deleteButton.classList.remove('is-danger');
      window.location.href = `/user/ldap/uzivatel/${id}/odstranit`; // redirect on success
    },
    error: function () {
      errorDiv.classList.remove('is-hidden');
      deleteButton.classList.add('is-danger');
    },
  });
}

function getNumberFromUrl(url) {
  return url.split('/').filter(function (part) {
    return part !== '' && !isNaN(part);
  });
}
